import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c98b74a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ml-5 mr-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, " GETRaNKE ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExpansionPanelDrinks = _resolveComponent("ExpansionPanelDrinks")!
  const _component_ExpansionPanelZusatzstoffe = _resolveComponent("ExpansionPanelZusatzstoffe")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_v_expansion_panels, null, {
      default: _withCtx(() => [
        _createVNode(_component_ExpansionPanelDrinks, {
          title: "Heißgetränke",
          products: _ctx.hotDrinks
        }, null, 8, ["products"]),
        _createVNode(_component_ExpansionPanelDrinks, {
          title: "Alkoholfreie Getränke",
          products: _ctx.noAlcDrinks
        }, null, 8, ["products"]),
        _createVNode(_component_ExpansionPanelDrinks, {
          title: "Bier",
          products: _ctx.beer
        }, null, 8, ["products"]),
        _createVNode(_component_ExpansionPanelDrinks, {
          title: "Longdrinks",
          products: _ctx.longDrinks
        }, null, 8, ["products"]),
        _createVNode(_component_ExpansionPanelDrinks, {
          title: "Cocktails",
          products: _ctx.cocktails
        }, null, 8, ["products"]),
        _createVNode(_component_ExpansionPanelDrinks, {
          title: "Alkoholfreie Cocktails",
          products: _ctx.noAlcCocktails
        }, null, 8, ["products"]),
        _createVNode(_component_ExpansionPanelDrinks, {
          title: "Aperitifs",
          products: _ctx.aperitifs
        }, null, 8, ["products"]),
        _createVNode(_component_ExpansionPanelDrinks, {
          title: "Wein",
          products: _ctx.vine
        }, null, 8, ["products"]),
        _createVNode(_component_ExpansionPanelDrinks, {
          title: "Shots",
          products: _ctx.shots
        }, null, 8, ["products"]),
        _createVNode(_component_ExpansionPanelDrinks, {
          title: "Flaschen",
          products: _ctx.bottles
        }, null, 8, ["products"]),
        _createVNode(_component_ExpansionPanelZusatzstoffe)
      ]),
      _: 1
    })
  ]))
}